export default __webpack_public_path__ + "static/media/neshan.cb6a4e81.png";